
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { TSocItem_Table } from "@/models/soc_items";
import { SMQuestionnaire } from "@/store";

const CLASS_NAMESPACE = "soc-item";

const ICONS = {
  down: "chevron-down-outline",
  up: "chevron-up-outline",
};

const MESSAGES = {
  buttons: {
    select: "Select",
  },
};
@Component({
  components: {
    SocTableItemDescription: () => import("@/components/SocTable/SocTableItemDescription.vue"),
  },
})
export default class SocTableItem extends Vue {
  @Prop({ type: Object, default: () => ({}) }) readonly src?: TSocItem_Table;
  @Prop({ type: Boolean, default: false }) readonly selected?: boolean;
  @Prop({ type: Boolean, default: false }) readonly expand?: boolean;

  icons = ICONS;
  messages = MESSAGES;

  body = this.expand;

  @Watch("expand", { immediate: true })
  setExpandChanged(value: boolean) {
    this.body = value;
  }

  get dropdownIcon(): string {
    return this.body ? this.icons.up : this.icons.down;
  }

  get classes(): object {
    const { selected } = this;

    return {
      [`${CLASS_NAMESPACE}_selected`]: selected,
    };
  }

  toggleBody(): void {
    this.body = !this.body;
  }

  get selectButtonProps(): object {
    return {};
  }

  select(): void {
    if (!this.src) return;

    this.$emit("select", this.src);
  }

  get isSelectButtonDisabled() {
    if (this.selected) return true;

    if (!this.src.soc_code_eligible_for_outside && SMQuestionnaire.isSelectButtonDisabled)
      return true;

    return false;
  }
}
